module.exports = __webpack_public_path__ + "static/fonts/iconfont.3982321.ttf";